import { useQuery } from '@tanstack/react-query';

import { productRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useEntitlement = (feature: string, activity: string) => {
  const query = useQuery({
    queryKey: [QueryKeys.ENTITLEMENT],
    queryFn: () => {
      return productRepo.getEntitlements(feature, activity);
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseEntitlement = ReturnType<typeof useEntitlement>;
